import { render, staticRenderFns } from "./ShortlistsPage.vue?vue&type=template&id=62f01e6a&"
import script from "./ShortlistsPage.vue?vue&type=script&lang=js&"
export * from "./ShortlistsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports